import styled from "styled-components";

export const ContactUsFormStyle = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  .single-column,
  .submit-button {
    grid-column: 1 / 3;
  }

  .single-column label {
    line-height: 1.6;
  }

  .single-column a {
    color: #d91e18;
    font-weight: 700;
    text-decoration: underline;
  }

  .single-column a:hover {
    color: #ff8500;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;

    .single-column,
    .submit-button {
      grid-column: 1;
    }
  }
`;

